<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2020-10-09 09:26:15
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2023-12-25 15:26:28
 * @FilePath: /platform/src/components/common/FeAvatar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-avatar :src="userPhoto">
    <img :src="userPhoto" />
  </el-avatar>
</template>

<script>
export default {
  props: ["user"],
  data() {
    return {
      userPhoto: null,
      userPhotoUrl: null,
      defaultUserPhoto: wwindow.location.origin + "/img/defaultPhoto.jpg"
    };
  },
  watch: {
    user: {
      handler: function(val, oldVal) {
        if (
          val &&
          val.user &&
          val.user.photo &&
          val !== oldVal &&
          val.user.photo != "/img/defaultPhoto.jpg"
        ) {
          this.$store.dispatch("menu/downloadImg", val.user.photo).then(res => {
            if (res != "") {
              this.userPhoto = res;
            } else {
              this.userPhoto = this.defaultUserPhoto;
            }
          });
        } else {
          this.userPhoto = this.defaultUserPhoto;
        }
      },
      deep: true
    }
  }
};
</script>
